import { Stack } from '@mui/material';
import { SectionsCollapsePMC8266 } from '@pages/cameras/hook/useMilesightPMC8266';
import { ComponentType, Fragment } from 'react';
import ParkingSpaceDetectionPMC8266 from './components/PMC8266_ParkingMilesights';
import StoragePMC8266 from './components/PMC8266_StorageMilesights';
import MotionDetectionPMC8266 from './components/PMC8266_MotionDetectionMilesights';
import DateAndTimeMilesightsPMC8266 from './components/PMC8266_DateAndTimeMilesights';

interface SectionProps {
    isOpenCollapse: { [key in SectionsCollapsePMC8266]: boolean };
    handleToggleCollapse: (section: SectionsCollapsePMC8266) => void;
}

type SectionComponent = ComponentType<SectionProps>;

const sections: SectionComponent[] = [
    ParkingSpaceDetectionPMC8266,
    StoragePMC8266,
    MotionDetectionPMC8266,
    DateAndTimeMilesightsPMC8266,
];

type Props = {
    isOpenCollapse: { [key in SectionsCollapsePMC8266]: boolean };
    handleToggleCollapse: (section: SectionsCollapsePMC8266) => void;
};

export default function MileSightPMC8266Page({ isOpenCollapse, handleToggleCollapse }: Props) {
    return (
        <Stack width="100%" direction="column" spacing={2}>
            {sections.map((Component, index) => (
                <Fragment key={index}>
                    <Component isOpenCollapse={isOpenCollapse} handleToggleCollapse={handleToggleCollapse} />
                </Fragment>
            ))}
        </Stack>
    );
}
